/**
 * Minimal RFC-4180-ish CSV tokenizer shared by the Google-Sheet loaders.
 * Character-based so quoted cells with commas / embedded newlines stay intact
 * (the gviz endpoint also adds stray whitespace/newlines inside cells).
 * @returns {string[][]} rows (trailing fully-empty rows removed)
 */
export function tokenizeCSV(csvText) {
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;

  for (let i = 0; i < csvText.length; i++) {
    const c = csvText[i];
    if (inQuotes) {
      if (c === '"') {
        if (csvText[i + 1] === '"') { field += '"'; i++; } else { inQuotes = false; }
      } else {
        field += c;
      }
      continue;
    }
    if (c === '"') inQuotes = true;
    else if (c === ',') { row.push(field); field = ''; }
    else if (c === '\r') { /* CRLF — handled by \n */ }
    else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
    else field += c;
  }
  if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }
  while (rows.length && rows[rows.length - 1].every((v) => !v || !v.trim())) rows.pop();
  return rows;
}
